import {IBizPromotion, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {APromotion} from "@/views/editor/service/promotion/promotion";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {INotifyRole} from "@/views/editor/service/types";

export default class TierGroup extends APromotion implements IBizPromotion {
    subs: CheckboxOptionType[] = [];

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }


    resetMeta(): IBusiness {
        return this;
    }

    roles(): INotifyRole[] {
        return [
            {
                name: '团长',
                is_virtual: false,
                events: {
                    'pms.activity.business.promotion.tire_group.leader.open': '开团',
                },
                is_status_multiple: false,
                status: []
            },
            {
                name: '团成员',
                is_virtual: false,
                events: {
                    'pms.activity.business.promotion.tire_group.member.join': '参团',
                },
                is_status_multiple: false,
                status: []
            },
            {
                name: '团',
                is_virtual: true,
                events: {
                    'pms.activity.business.promotion.tire_group.group.open': '开团',
                    'pms.activity.business.promotion.tire_group.group.join': '参团',
                    'pms.activity.business.promotion.tire_group.group.success': '成团',
                    'pms.activity.business.promotion.tire_group.group.full': '满团',
                },
                is_status_multiple: false,
                status: ['未成团', '成团', '满团']
            },
        ]
    }
}